import { Button, Stack } from '@mui/material';
import { useCallback } from 'react';

import styles from './styles';

interface PaginationProps {
  total: number;
  page: number;
  onChange: (value: number) => void;
  disabled?: boolean;
}

const Pagination = ({
  total,
  onChange,
  page,
  disabled = false,
}: PaginationProps): JSX.Element => {
  const onClickPrv = useCallback(() => {
    onChange(page - 1);
  }, [onChange, page]);

  const onClickNext = useCallback(() => {
    onChange(page + 1);
  }, [onChange, page]);

  return (
    <Stack sx={styles.root}>
      <Button
        variant="contained"
        color="primary"
        disabled={disabled || page === 1}
        onClick={onClickPrv}
      >
        Anterior
      </Button>
      <Button
        variant="contained"
        color="primary"
        disabled={disabled || page === total}
        onClick={onClickNext}
      >
        Próximo
      </Button>
    </Stack>
  );
};

export default Pagination;
